import { render, staticRenderFns } from "./PoweredByDentCloud.vue?vue&type=template&id=dab75ad4&scoped=true"
import script from "./PoweredByDentCloud.vue?vue&type=script&lang=js"
export * from "./PoweredByDentCloud.vue?vue&type=script&lang=js"
import style0 from "./PoweredByDentCloud.vue?vue&type=style&index=0&id=dab75ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab75ad4",
  null
  
)

export default component.exports